<template>
    <module-card next="/" nextLabel="Finish" :nextFunction="finish">
        <p class="text-h6 text-center" v-if="title">{{ title }}</p>
        <slot name="intro"></slot>
        <v-img class="mx-auto my-6" :max-width="200" :src="require(`@/assets/trophies/${module.id}.png`)" :alt="`Trophy: ${module.title}`"></v-img>
        <slot></slot>
    </module-card>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: null
            }
        },
        computed: {
            module() {
                return this.$store.get('module', this.$route.params.module);
            }
        },
        methods: {
            finish() {
                this.$store.commit('complete', this.module);
            }
        }
    };
</script>
